import "./style.css";
import ReactDOM from "react-dom/client";
import { Canvas } from "@react-three/fiber";
import { KeyboardControls, useProgress } from "@react-three/drei";
import { StrictMode, Suspense } from "react";

import Experience from "./Experience.js";
import Interface from "./Interface";
import Attendre from "./Attendre";

const root = ReactDOM.createRoot(document.querySelector("#root"));

root.render(

  <StrictMode>
    <KeyboardControls
      map={[
        { name: 'forward', keys: ['ArrowUp', 'KeyW'] },
        { name: 'backward', keys: ['ArrowDown', 'KeyS'] },
        { name: 'leftward', keys: ['ArrowLeft', 'KeyA'] },
        { name: 'rightward', keys: ['ArrowRight', 'KeyD'] }
      ]}
    >
      <Suspense fallback={<Attendre />}>
        <Canvas
          flat
          camera={{
            fov: 45,
            near: 0.1,
            far: 200
          }}
        >
          <Experience />

        </Canvas>
        <Interface />
      </Suspense>
    </KeyboardControls>
  </StrictMode>

);
